import pkg from '../../../package.json'

'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:MainCtrl
 * @description
 * # MainCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers', [])
  .controller('MainCtrl', ['$rootScope', '$state', 'Session', '$window', 'GoogleApi', '$mdDialog', 'User', 'AppSetting',
  function ($rootScope, $state, Session, $window, GoogleApi, $mdDialog, User, AppSetting ) {
    var currentUser = {
      id: 0
    };
    $rootScope.$state = $state;

    $rootScope.logout = function() {
      Session.logout();
    };

    $window.initGapi = function() {
      GoogleApi.init();
    };

    $rootScope.appVersion = pkg.version;
    
    let getAppSetting = AppSetting.getAppSettings();
    getAppSetting.catch(error => {
      console.error('Error:', error);
    });

    // El menu de cambios de alcance solo lo ve quien tiene el rol.
    if ('apiUser' in $window.localStorage) {
      $rootScope.isScopeChangeApprover = JSON.parse($window.localStorage.apiUser).project_management_role === true;
    }

    $rootScope.EstimatedHoursCtrl = ['$scope', function($scope) {
      $scope.estimationHash = {
        'estimated_hours': '',
        'employee_position_name': ''
      };

      $scope.save = function() {
        $mdDialog.hide($scope.estimationHash);
      };
      $scope.cancel = function() {
        $mdDialog.cancel();
      };
    }];

    $rootScope.CommentCtrl = ['$scope', function($scope) {
      $scope.commentHash = {
        'comment': '',
        'date': new Date(),
        'rape_id': $scope.projectHash.project.rape_id,
        'name': '',
        'project_type_catalog_id': '',
        'id': $scope.projectHash.project.id,
        'eta': $scope.projectHash.project.eta
      };

      if('project' in $scope.projectHash) {
        $scope.commentHash.id = $scope.projectHash.project.id;
      }

      $scope.save = function() {
        $mdDialog.hide($scope.commentHash);
      };
      $scope.cancel = function() {
        $mdDialog.cancel();
      };
    }];

    $rootScope.QuoteCommentCtrl = ['$scope', function($scope) {
      $scope.commentHash = {
        'comment': '',
        'client_code': '0',
        'project_name': '',
        'project_date': new Date(),
        'eta': new Date(),

      };
      $scope.save = function() {
        $mdDialog.hide($scope.commentHash);
      };
      $scope.cancel = function() {
        $mdDialog.cancel();
      };
    }];

    $rootScope.readByDialogController = ['$scope', '$mdDialog', 'readers',function($scope, $mdDialog, readers) {
      $scope.readers = readers;
      $scope.cancel = function() {
        $mdDialog.cancel();
      };
    }];

    if ('apiUser' in $window.localStorage) {
      $rootScope.userIsAdmin = JSON.parse($window.localStorage.apiUser).administrator_role;
      $rootScope.myUser = JSON.parse($window.localStorage.apiUser);
      if([undefined, null].includes(JSON.parse($window.localStorage.apiUser).employee)) {
        $rootScope.hasEmployee = false;
      } else {
        $rootScope.hasEmployee = true;
        $rootScope.myEmployee = JSON.parse($window.localStorage.apiUser).employee;
      }
    }

}]);
